var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.UnauthorizedLayout, {
    attrs: {
      "with-login-button": false,
      "with-back-link": true,
      "has-footer": false
    }
  }, [_c(_setup.CustomTemplateWithLeftBlock, {
    attrs: {
      "aside-width": "33.33%"
    }
  }), _vm._v(" "), _c(_setup.TheModal)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };